import React,{useState, useEffect} from "react"
import { Link,useNavigate,useParams } from "react-router-dom";
import axios from "axios";
import {decode} from 'html-entities';
import ReactReadMoreReadLess from 'react-read-more-read-less'
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import moment from "moment";
import { WorkshopListURL } from "../../../apis/urls";
import { $ } from "react-jquery-plugin";


const WorkshopMultipleView = () => {

    useEffect(() => {
        $('html,body').animate({ scrollTop: 0 }, 'fast');
        EventViews();
    },[]
    );


    const {wid,sid, id } = useParams();
    const[ result,setResult ] = useState('');
    const[ sessions,setSessions ] = useState('');
    const[ description,setDescription ] = useState('');
    const[ seat,setSeat ] = useState();

    let navigate = useNavigate();


    const EventViews = ()=>{
        let token = "Bearer "+localStorage.getItem('token');
        //console.log(token)

        const instance = axios.create({
            baseURL: WorkshopListURL+'/view/multiple/'+id,
            timeout: 1000000,
            headers: {'authorization': token}
        });

        instance.get('').then(res => {
            console.log(res.data.data)
            setResult(res.data.data);
            setSessions(res.data.data.sessions)
            setSeat(res.data.usedSeat)
            let desc = decode(res.data.data.description)


            setDescription(ReactHtmlParser(desc))



            console.log(JSON.stringify(desc).length)
          });

    }


    const DeleteEvent = () => {

        let r = window.confirm("Are you sure you want to delete this Workshop?");

        if(r == true){
            
            let token = "Bearer "+localStorage.getItem('token');
        
        
            const instance = axios.create({

                baseURL: WorkshopListURL+'/delete/multiple/'+id,

                timeout: 1000000,

                headers: {'authorization': token}

            });
            
            instance.delete('').then((response) =>{
                
                navigate("/workshop/session/"+wid+"/"+sid)
            
            }).catch((error) =>{
                
                console.log('error',error.message)
            });
        }
    }








    return(
        <div>
            <aside class="right-side areas">    
                <div class="content-area dash-contentss">







                <div className="page-title-wrpr">
                        <div className="page-title-left-column">
                            
                            <h2 className="page-title">Workshops - {result.topic}</h2>
                        </div>
                        <div className="page-rightside-action-column">
                            
                            
                        </div>
                    
                    
                    </div>

 
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/workshop">Conference Manager</Link></li>
                            <li className="breadcrumb-item active" aria-current="page"><Link to={"/sessions/"+wid}>Sessions</Link></li>
                            <li className="breadcrumb-item active" aria-current="page"><Link to={"/workshop/session/"+wid+"/"+sid}>Workshop</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">View Workshop</li>
                        </ol>
                    </nav>





                <div class="event-details-wrprs" style={{margin:"auto"}}>


                <div class="row">
            <div class="col-md-12">
              <div class="row event-basic-details-wrpr">
                <div class="col-md-6">
                    {result.image?
                        <img src={result.image} width="" height="100%" alt="" />:
                        <div className="img-wrpr" />
                    }
                </div>
                <div class="col-md-6 event-basic-details">
                  <h2>{result.topic}</h2>
                    {description}

                  <div class="date-time-seats">
                    <div class="date-time">
                      <label>Date &amp; Time</label>
                      <div class="starttime-endtime">
                      <div class="starttime">{moment(result.start_date).format('ddd, MMM DD, YYYY hh:mm A')}</div>
                      <i class="icon-arrow-right1"></i>
                      <div class="endtime">{moment(result.end_date  ).format('ddd, MMM DD, YYYY hh:mm A')}</div>
                      </div>
                      
                    </div>

                    <div class="seats-wrpr">
                      <label>Seats</label>
                      <div class="progress" style={{width:"120px",height:'25px'}}>
                        <div class="progress-bar progress-bar-striped" style={{width:(seat/result.max_seats)*100+"%", fontSize:'15px'}}>
                          {seat}/{result.max_seats}
                        </div>
                      </div>
                    </div>
                  </div>



                  <div class="fees-wrpr">
                        <div class="member-fee">
                        <label>Presenter Title</label>
                        <div class="fee-content">
                            {result.presenter_title}
                        </div>
                        </div>
                        <div class="member-fee">
                        <label>Presenter Name</label>
                        <div class="fee-content">
                            {result.presenter_name}
                        </div>
                        </div>
                        <div class="member-fee">
                        <label>Presenter Organization</label>
                        <div class="fee-content">
                            {result.presenter_organization}
                        </div>
                        </div>
                    </div>


                    <div className="list-action-wrpr showicons roundicons-text" style={{marginTop:'10%'}}>
                        <div className="list-action-wrpr">
                        <Link to={"/workshop/session/update/"+wid+'/'+sid+'/'+result.id} data-toggle="tooltip" title="Edit"><i  class="edit icon-pencil3"></i><span>Update</span></Link>
                        <button onClick={DeleteEvent} style={{background:"transparent"}} data-toggle="tooltip" title="Delete"><a><i class="delete icon-close1"></i><span>Delete</span></a></button>
                        </div>
                    </div>

                  


  
  
                </div>  
              </div>
            </div>
          </div>



                    </div>
                </div>
            </aside>

        </div>
    )
}

export default WorkshopMultipleView;